import React, { useState, useEffect } from "react";
import { Column } from "@ant-design/plots";
import { Empty, Spin } from "antd";

const PosColumnChart = (props) => {
  const data = props.data.map((item) => ({
    type: `${item.terminalNumber}\n\n${item.bankName}`,
    sales: item.transactionCount,
  }));

  if (data.length === 0) {
    return <Empty description="Veri Yok" />;
  }

  if (props.isLoading) {
    return (
      <div style={{ textAlign: "center", position: "relative" }}>
        <Spin size="small" />
      </div>
    );
  }

  const config = {
    data,
    xField: "type",
    yField: "sales",
    label: {
      position: "top",
      style: {
        fill: "#000000",
        opacity: 0.6,
      }, style: {
        fontSize: 18,
      },
    },
    xAxis: {
      title: {
        text: "Terminal Numarası",
        style: {
          fontSize: 20,
        },
      },
      label: {
        autoHide: false,
        autoRotate: false,
      },
    },
    yAxis: {
      title: {
        text: "İşlem Sayısı",
        style: {
          fontSize: 20,
        },
      },
    },
    meta: {
      type: {
        alias: "Terminal Numarası ve Banka Numarası",
      },
      sales: {
        alias: "İşlem Adedi",
      },
    },
    columnWidthRatio: 0.2,
    style: { 
      fonstSize:500,
      width: "100%",
      margin: "0 auto",
      padding: "20px",
      backgroundColor: "#FFFFFF",
      border: "1px solid #ccc",
      borderRadius: "7px",
      boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    },
  };
  return <Column {...config} />;
};

export default PosColumnChart;
